import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { DEFAULT_OFFERING_ICON_SIZES } from '../configs'
import { TOfferingsIconSizes } from '../models/icon'

interface IParams {
  offering: ProgramTypes
  sizesMap?: Partial<TOfferingsIconSizes>
}

export const getIconSize = ({ offering, sizesMap }: IParams) => {
  const defaultIconSize = DEFAULT_OFFERING_ICON_SIZES[offering] || {}
  if (!sizesMap) {
    return defaultIconSize
  }

  const newIconSize = sizesMap[offering] || {}
  return {
    ...defaultIconSize,
    ...newIconSize,
  }
}
